<template>
  <div class="resource-passwords">
    <div class="header-title">{{ $t('newProject.resources.password') }}</div>
    <resource-password-row v-for="item in items" :key="item.id" :password="item.password" />
  </div>
</template>

<script>
import ResourcePasswordRow from './ResourcePasswordRow.vue';

export default {
  name: 'ResourceLogins',
  components: { ResourcePasswordRow },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-passwords {
  .header-title {
    padding: $space-1-5;
    display: inline-flex;
    color: var(--text-tertiary);
    font-size: $font-size-xs;
    letter-spacing: 0.8px;
    line-height: $font-size-xs;
    text-transform: uppercase;
  }
}
</style>
